(function () {

    angular
        .module('smartertoolsApp')
        .service('supportService', ['$http', 'refreshToken', 'cacheControl', '$q', supportService]);

    function supportService($http, refreshToken, cacheControl, $q) {
        const vm = this;
        vm.urlBase = apiRootUrl;
        let getSupportInventoryPromise;
        let getRsaasPromise;
        let getAllTicketsPromise;
        let getTicketsAndRsaaPromise;

        // Functions
        vm.getSupportInventory = getSupportInventory;
        vm.getRsaas = getRsaas;
        vm.startRsaa = startRsaa;
        vm.getOpenSupportTickets = getOpenSupportTickets;
        vm.resetCache = resetCache;
        vm.doEditRsaa = editRsaa;
        vm.getAllTickets = getAllTickets;
        vm.getAllTicketsWithRSAA = getAllTicketsWithRSAA;

        activate();

        // -----------------------------------------------

        function activate() {
        }

        function getSupportInventory() {
            if (getSupportInventoryPromise)
                return getSupportInventoryPromise;
            getSupportInventoryPromise = refreshToken.refreshToken()
                .then(() => $http.get(vm.urlBase + 'v1/account/support/inventory', {cache: cacheControl.getCache('invoiceCache')}))
                .then((response) => {
                    getSupportInventoryPromise = null;
                    return response.data.Items;
                })
                .catch((err) => {
                    getSupportInventoryPromise = null;
                    $q.reject(err);
                });
            return getSupportInventoryPromise;
        }

        function resetCache() {
            cacheControl.getCache('invoiceCache').remove(vm.urlBase + 'v2/account/support/rsaas');
            cacheControl.getCache('invoiceCache').remove(vm.urlBase + 'v1/account/support/inventory');
            cacheControl.getCache('invoiceCache').remove(vm.urlBase + 'v2/account/support/all-tickets');
            cacheControl.getCache('rsaaTicketCache').remove(vm.urlBase + 'v2/account/support/tickets-with-rsaa');
        }

        function getRsaas() {
            if (getRsaasPromise)
                return getRsaasPromise;
            getRsaasPromise = refreshToken.refreshToken()
                .then(() => $http.get(vm.urlBase + 'v2/account/support/rsaas', {cache: cacheControl.getCache('invoiceCache')}))
                .then((response) => {
                    getRsaasPromise = null;
                    return response.data.Items;
                })
                .catch((err) => {
                    getRsaasPromise = null;
                    $q.reject(err);
                });
            return getRsaasPromise;
        }

        function getAllTickets() {
            if (getAllTicketsPromise)
                return getAllTicketsPromise;
            getAllTicketsPromise = refreshToken.refreshToken()
                .then(() => $http.get(vm.urlBase + 'v2/account/support/all-tickets', {cache: cacheControl.getCache('invoiceCache')}))
                .then((response) => {
                    getAllTicketsPromise = null;
                    return response.data;
                })
                .catch((err) => {
                    getAllTicketsPromise = null;
                    $q.reject(err);
                });
            return getAllTicketsPromise;
        }

        function getAllTicketsWithRSAA() {
            if (getTicketsAndRsaaPromise)
                return getTicketsAndRsaaPromise;
            getTicketsAndRsaaPromise = refreshToken.refreshToken()
                .then(() => $http.get(vm.urlBase + 'v2/account/support/tickets-with-rsaa', {cache: cacheControl.getCache('rsaaTicketCache')}))
                .then((response) => {
                    getTicketsAndRsaaPromise = null;
                    return response.data;
                })
                .catch((err) => {
                    getTicketsAndRsaaPromise = null;
                    $q.reject(err);
                });
            return getTicketsAndRsaaPromise;
        }

        function getOpenSupportTickets() {
            return refreshToken.refreshToken()
                .then(() => $http.get(vm.urlBase + 'v2/account/support/open-tickets'))
                .then((response) => response.data);
        }

        function startRsaa(rsaa) {
            return refreshToken.refreshToken()
                .then(() => $http.post(vm.urlBase + 'v2/account/support/start-rsaa', JSON.stringify(rsaa)))
                .then((response) => response.data);
        }

        function editRsaa(rsaa) {
            return refreshToken.refreshToken()
                .then(() => $http.post(vm.urlBase + 'v2/account/support/edit-rsaa', JSON.stringify(rsaa)))
                .then((response) => response.data);
        }
    }

})();